import { render, staticRenderFns } from "./saml_authorize.vue?vue&type=template&id=134599ff"
import script from "./saml_authorize.vue?vue&type=script&lang=js"
export * from "./saml_authorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports